import {Component, OnInit} from '@angular/core';
import {IDialogComponent} from '../../../../../common/dialog/iDialog.component';
import {DialogWithInput} from '../../../../../common/dialog/dialogWithInput';
import {BaseView} from '../../../../../core/view/base.view';
import {FormBuilder, FormControl, FormGroup, Validators} from '@angular/forms';
import {BehaviorSubject} from 'rxjs';
import {SelectFilterElement} from '../../../../../../components/common/select-filter/select-filter.model';
import {AuthService} from '../../../../../auth/api/service/auth.service';
import {JwtTokenModel} from '../../../../../auth/api/service/jwtToken.model';
import {JwtTokenAccountModel} from '../../../../../auth/api/service/jwtTokenAccount.model';
import {JwtProviderModel} from '../../../../../auth/api/service/jwtProvider.model';
import {SubscriptionPaginatedService} from '../../../../../subscription/api/service/subscriptionPaginated.service';
import {Operator, Order, Sort, UrlParameter} from '../../../../../../shared/utils/url.builder';
import {UrlParameterBuilder} from '../../../../../core/http/UrlParameterBuilder';
import {AccountSummary} from "../../../../../../shared/model/account/accountSummary.model";
import {
  SubscriptionSummaryPaginatedService
} from "../../../../../subscription/api/service/subscriptionSummaryPaginated.service";
import {SubscriptionFindOneByIdService} from "../../../../../subscription/api/service/subscriptionFindOneById.service";
import {SubscriptionSummaryModel} from "../../../../../subscription/api/entity/subscriptionSummary.model";

@Component({
  selector: 'app-account-change-dialog',
  templateUrl: './account-change-dialog.component.html',
  providers: [
      SubscriptionSummaryPaginatedService,
      SubscriptionFindOneByIdService,
  ]
})
export class AccountChangeDialogComponent extends BaseView implements
    IDialogComponent<void, void>, OnInit{
  dialog: DialogWithInput<void, void>;
  formGroupAdditionalAccount: FormGroup;
  formGroupCustomerAccount: FormGroup;

  token: JwtTokenModel;
  additionalAccountElements: BehaviorSubject<SelectFilterElement<string, JwtTokenAccountModel>[]>
      = new BehaviorSubject<SelectFilterElement<string, JwtTokenAccountModel>[]>([]);
  providerAccountElements: BehaviorSubject<SelectFilterElement<string, JwtProviderModel>[]>
      = new BehaviorSubject<SelectFilterElement<string, JwtProviderModel>[]>([]);

  subscriptionParameters: UrlParameter[] = [];
  subscriptionSort = new Sort('account.name', Order.ASCENDING);

  constructor(private formBuilder: FormBuilder,
              public service: SubscriptionSummaryPaginatedService,
              public findOneService: SubscriptionFindOneByIdService,
              private  authService: AuthService) {
    super();
    this.formGroupAdditionalAccount = this.formBuilder.group({
      account: new FormControl(undefined, Validators.required)
    });
    this.formGroupCustomerAccount = this.formBuilder.group({
        providerAccount: new FormControl(undefined, Validators.required),
        account: new FormControl(undefined, Validators.required),
        accountName: new FormControl(undefined),
    });

    this.token = this.authService.tokenContentSnapshot;
    if (this.token.additionalAccounts.length > 0) {
      this.additionalAccountElements.next(this.token.additionalAccounts
          .sort((a, b) => a.name.localeCompare(b.name))
          .map(value => {
        return new SelectFilterElement<string, JwtTokenAccountModel>(value.businessCode, value.businessCode, value);
      }));
    }

    if (this.token.providers.length > 0) {
      this.providerAccountElements.next(this.token.providers
          .sort((a, b) => a.providerBusinessCode.localeCompare(b.providerBusinessCode))
          .map(value => new SelectFilterElement<string, JwtProviderModel>(value.providerBusinessCode, value.providerBusinessCode, value)));
    }
  }

  ngOnInit(): void {
  }

  selectAccount(accountBusinessCode: string) {
    if (accountBusinessCode) {
      this.redirectToWithinCurrentApp('account-change/' + encodeURIComponent(accountBusinessCode));
      this.dialog.close();
    }
  }

  selectSubscription(subscription: SubscriptionSummaryModel) {
    this.findOneService.loadEntity(subscription.id)
        .then(value => this.selectAccount(value.account.businessCode));
  }

  providerSelected(selectedItem: SelectFilterElement<string, JwtProviderModel>) {
    if (selectedItem) {
      this.formGroupCustomerAccount.patchValue({
        account: undefined
      });
    }
    this.refreshSubscriptionParameters();
  }

  accountNameChanged() {
    if (this.formGroupCustomerAccount.value.accountName?.length > 2) {
      this.refreshSubscriptionParameters();
    }
  }

  refreshSubscriptionParameters() {
    this.subscriptionParameters = [];
    this.subscriptionParameters = new UrlParameterBuilder()
        .addParameter('type', 'PROVIDER', Operator.EQUALS)
        .addNullParameter('endDate')
        .addParameter('providerService.provider.businessCode', this.formGroupCustomerAccount.value.providerAccount, Operator.EQUALS)
        .addParameter('account.name', this.formGroupCustomerAccount.value.accountName, Operator.LIKE)
        .parameters;
  }


  filterAccount = (criteria: string, entity: JwtTokenAccountModel) => {
    return (entity.name).toUpperCase().indexOf(criteria.toUpperCase()) > -1;
  }

  filterProvider = (criteria: string, entity: JwtProviderModel) => {
    return (entity.name).toUpperCase().indexOf(criteria.toUpperCase()) > -1;
  }

}
